import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFactory = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.95 0C0.424531 0 0 0.469219 0 1.05V13.125C0 13.9945 0.638281 14.7 1.425 14.7H13.775C14.5617 14.7 15.2 13.9945 15.2 13.125V3.94406C15.2 3.34687 14.6241 2.96953 14.1491 3.25172L9.5 6.01781V3.94406C9.5 3.34687 8.92406 2.96953 8.44906 3.25172L3.8 6.01781V1.05C3.8 0.469219 3.37547 0 2.85 0H0.95Z",
		fill: "white"
	})
});
export default SvgFactory;
